import React, { ReactElement, Fragment, PureComponent } from 'react';
import { Item as ProductItem } from '~/Api/Product';
import { PricedProduct } from '~/Product';
import { Link } from '~/UI/Button';
import Heading from '~/UI/Heading';
import Icon from '~/UI/Icon';
import Tooltip from '~/UI/Tooltip';
import grayTooltipStyles from '~/UI/Tooltip/gray.less';

import styles from './styles.less';

type Product = PricedProduct<ProductItem>;
interface Props {
	reference: ReactElement<any>;
	pricedProduct: Product;
	styles: {
		list: string;
		item: string;
		link: string;
	};
}

export default class ListsTooltip extends PureComponent<Props> {
	static defaultProps = {
		styles,
	};

	render() {
		const { reference, pricedProduct, styles } = this.props;

		return (
			<Tooltip position='right' reference={reference} styles={grayTooltipStyles}>
				<Heading level={3}>
					<strong>{"Product's"} lists:</strong>
				</Heading>
				<ul className={styles.list}>
					{pricedProduct.item.memberOfLists.map((list) => (
						<li className={styles.item} key={list.id}>
							{list.parent !== null ? (
								<Fragment>
									<Link styles={{ button: styles.link }} to={`/product-groups/${encodeURIComponent(list.parent.id)}`}>
										{list.parent.name}
									</Link>
									<Icon name='next' />
								</Fragment>
							) : null}

							<Link styles={{ button: styles.link }} to={`/product-groups/${encodeURIComponent(list.id)}`}>
								{list.name}
							</Link>
						</li>
					))}
				</ul>
			</Tooltip>
		);
	}
}
